interface IconProps {
  className?: string;
}

export function CircleCIIcon({ className }: IconProps) {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 32 32"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>file_type_circleci</title>
      <path
        d="M12.458,16a3.332,3.332,0,1,1,3.332,3.332A3.331,3.331,0,0,1,12.458,16ZM15.79,2A14.015,14.015,0,0,0,2.224,12.528a.432.432,0,0,0-.014.14.672.672,0,0,0,.672.672H8.524a.645.645,0,0,0,.6-.392h0a7.336,7.336,0,1,1,0,6.1h0a.684.684,0,0,0-.6-.392H2.882a.672.672,0,0,0-.672.672c0,.042.014.084.014.14A14,14,0,1,0,15.79,2Z"
        fill="#064c64"
      />
    </svg>
  );
}
